import { render, staticRenderFns } from "./FallbackTravelSection.vue?vue&type=template&id=95b42c34"
import script from "./FallbackTravelSection.vue?vue&type=script&lang=ts"
export * from "./FallbackTravelSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports